import {useMutation, useQuery, useQueryClient, UseQueryOptions, UseQueryResult} from '@tanstack/react-query';
import {fetchFeatures, updateFeature} from '~/modules/Features/api';
import {IFeature, IFeatureUpdate} from '~/modules/Features/models/Feature';

export const FEATURES_QUERY_KEY = ['features'] as const;

const queryDefaults = {
    staleTime: 60_000,
    gcTime: 10 * 60_000,
} as const;

export const useFeaturesQuery = (
    options?: Omit<UseQueryOptions<IFeature[]>, 'queryKey' | 'queryFn'>
): UseQueryResult<IFeature[]> =>
    useQuery<IFeature[]>({
        queryKey: FEATURES_QUERY_KEY,
        queryFn: fetchFeatures,
        ...queryDefaults,
        ...options,
    });

export const useUpdateFeatureMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({name, update}: {name: string; update: IFeatureUpdate}) => updateFeature(name, update),
        onSuccess: () => queryClient.invalidateQueries({queryKey: FEATURES_QUERY_KEY}),
    });
};
